import React from "react";
import { Box, Typography, Container} from "@mui/material";
import { styled } from "@mui/material/styles";

const HeroSection = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  background: "linear-gradient(45deg, #5BB5D9 30%, #1B7A9F 90%)",
  color: "white",
  position: "relative",
  overflow: "hidden",
}));

const FleetManagement = () => {
  return (
    <HeroSection>
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            gap: 4,
          }}
        >
          <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
            <Typography variant="h2" component="h1" gutterBottom>
            Precision Tracking & Smart Insights for Maximum Efficiency
            </Typography>
            <Typography variant="h5" gutterBottom sx={{ mb: 4 }}>
            Optimize routes, fuel, and safety while reducing costs and enhancing productivity.
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src="images/IMAGE1.webp"
              alt="Fleet Management"
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </Box>
        </Box>
      </Container>
    </HeroSection>
  );
};

export default FleetManagement;
